import React, { useCallback } from 'react'

import { hooks, I18n } from '@front/volcanion'
import { FormDialog, DialogContent } from '@front/squirtle'

import Callbacks from './callbacks'
import Voucher from '@abra/frames/Voucher'


const VoucherForm = ({ record_id }) => {
  const [createVoucher] = hooks.useModelFunction('voucher', 'generate')
  const searchVoucher = hooks.useGlobalFormFunction('voucher_search', 'requestSubmit')
  const onSubmit = useCallback(Callbacks.onSubmitHandler(createVoucher, searchVoucher), [createVoucher, searchVoucher])
  const getSuccessNotification = useCallback(Callbacks.getSuccessNotificationHandler(), [])
  const getFailedNotification = useCallback(Callbacks.getFailedNotificationHandler(), [])

  return (
    <FormDialog
      name='voucher'
      title={I18n.t('voucher.popup.title')}
      maxWidth='lg'
      formProps={{
        onSubmit,
        getSuccessNotification,
        getFailedNotification,
        initialValues: { active: true }
      }}
    >
      <DialogContent>
        <Voucher company={record_id} isPopup />
      </DialogContent>
    </FormDialog>
  )
}

export default VoucherForm
